import { tooltipData, tooltipHelp } from "../createTooltip.js";
import DrawRectangle from "mapbox-gl-draw-rectangle-mode";

const _onMouseMove = DrawRectangle.onMouseMove;

DrawRectangle.onMouseMove = function (state, e) {
  const result = _onMouseMove.apply(this, [state, e]);

  const feature = state.rectangle.toGeoJSON();

  tooltipData([feature], "polygon");
  tooltipHelp([feature], "polygon");
  state.rectangle.properties.sysType = "polygon";
  state.rectangle.properties.sysData = tooltipData(
    [feature],
    "polygon",
    false,
    true
  );
  return result;
};

export default DrawRectangle;
